export default "__VITE_ASSET__bab4bd03__"